import React, { useState } from "react";
import { Box, IconButton, Paper, Typography, Alert, Chip } from "@mui/material";
import { Close as CloseIcon, Fullscreen as FullscreenIcon, Pages as PagesIcon } from "@mui/icons-material";
import ModalView from "./ModalView";

const PDFPreview = ({ 
  googleDriveUrl, 
  width = "100%", 
  height = "600px",
  title = "PDF Preview",
  showFullscreenButton = true,
  pageCount = null // เพิ่ม prop สำหรับจำนวนหน้า
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [error, setError] = useState(false);

  // แปลง Google Drive URL เป็น preview URL
  const convertToPreviewUrl = (url) => {
    try {
      // ดึง file ID จาก Google Drive URL
      const fileIdMatch = url.match(/\/d\/([a-zA-Z0-9-_]+)/);
      if (fileIdMatch) {
        const fileId = fileIdMatch[1];
        return `https://drive.google.com/file/d/${fileId}/preview`;
      }
      
      // หากเป็น URL รูปแบบอื่น ๆ
      if (url.includes('drive.google.com') && url.includes('id=')) {
        const urlParams = new URLSearchParams(url.split('?')[1]);
        const fileId = urlParams.get('id');
        if (fileId) {
          return `https://drive.google.com/file/d/${fileId}/preview`;
        }
      }
      
      return url; // ถ้าแปลงไม่ได้ให้ใช้ URL เดิม
    } catch (err) {
      console.error('Error converting URL:', err);
      return url;
    }
  };

  const previewUrl = convertToPreviewUrl(googleDriveUrl);

  const handleIframeError = () => {
    setError(true);
  };

  const handleFullscreen = () => {
    setIsFullscreen(true);
  };

  const handleCloseFullscreen = () => {
    setIsFullscreen(false);
  };

  const renderPDFViewer = (containerWidth, containerHeight, isFullscreenMode = false) => (
    <Box sx={{ position: 'relative', width: containerWidth, height: containerHeight }}>
      {/* Page Count Display */}
      {pageCount && (
        <Chip
          icon={<PagesIcon />}
          label={`${pageCount} หน้า`}
          size="small"
          color="info"
          sx={{
            position: 'absolute',
            top: 8,
            left: 8,
            zIndex: 10,
            backgroundColor: 'rgba(33, 150, 243, 0.9)',
            color: 'white',
          }}
        />
      )}
      
      {showFullscreenButton && !isFullscreenMode && (
        <IconButton
          onClick={handleFullscreen}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
          }}
        >
          <FullscreenIcon />
        </IconButton>
      )}
      
      {error ? (
        <Alert severity="error" sx={{ m: 2 }}>
          ไม่สามารถโหลด PDF ได้ กรุณาตรวจสอบ URL หรือสิทธิ์การเข้าถึงไฟล์
          <br />
          <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
            URL: {previewUrl}
          </Typography>
        </Alert>
      ) : (
        <iframe
          src={previewUrl}
          width="100%"
          height="100%"
          frameBorder="0"
          title={title}
          onError={handleIframeError}
          style={{
            border: 'none',
            borderRadius: isFullscreenMode ? '0px' : '4px',
          }}
        />
      )}
    </Box>
  );

  return (
    <>
      <Paper elevation={2} sx={{ overflow: 'hidden' }}>
        {renderPDFViewer(width, height, false)}
      </Paper>

      {/* Fullscreen Modal */}
      <ModalView
        isModaOpen={isFullscreen}
        setIsModalOpen={setIsFullscreen}
        title={title}
        onClose={handleCloseFullscreen}
      >
        <Box sx={{ width: '90vw', height: '90vh' }}>
          {renderPDFViewer('100%', '100%', true)}
        </Box>
      </ModalView>
    </>
  );
};

export default PDFPreview;
